module.exports = __webpack_public_path__ + "img/argo-sidebar-1.03b19a03.png";